export default "__VITE_PUBLIC_ASSET__b1627c27__"